import { identity } from "lodash";
import { Field } from "react-final-form";
import { Descendant, Editor, Transforms } from "slate";

import { FormattedTextEditor, IVariableSelectParams } from "components/rich-editor/formatted-text-editor";
import { RichTextVariables } from "components/rich-editor/plugins/constants";
import { VariableElement } from "components/rich-editor/types";
import { EventPlace, trackEngagement } from "helpers/analytics";

export const Footer = (): JSX.Element => (
  <Field<Descendant[]>
    name="appearance.footerBody.value.html"
    parse={identity}
    withDebounce
    render={FormattedTextEditor}
    // plugins added to the editor
    linksPlugin
    variablesPlugin
    handleVariableSelect={(editor: Editor) =>
      ({ label, content }: IVariableSelectParams): void => {
        const variable: VariableElement = {
          type: "htmlSnippet",
          label,
          content,
          children: [{ text: "" }],
        };
        Transforms.insertNodes(editor, variable);
        Transforms.move(editor);
        trackEngagement("Visual template editor: Footer add variable from list", EventPlace.Settings, {
          variableAdded: label,
        });
      }}
    variablesPluginOptions={[
      RichTextVariables.Message,
      RichTextVariables.RequesterName,
      RichTextVariables.ShortID,
      RichTextVariables.AgentName,
      RichTextVariables.Subject,
      RichTextVariables.PeopleInTheLoop,
    ]}
    richTextPlugin
    // customizing the richTextPlugin
    withBold
    withItalic
    withUnderline
    withStrikethrough
  />
);
